module.exports = __webpack_public_path__ + "static/media/2021-october-article.a5940d81.jpg";